import { render, staticRenderFns } from "./WarehouseNameIcon.vue?vue&type=template&id=187e02bd&scoped=true"
import script from "./WarehouseNameIcon.vue?vue&type=script&lang=js"
export * from "./WarehouseNameIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e02bd",
  null
  
)

export default component.exports